import { render } from "./AddNewRecipe.vue?vue&type=template&id=05177395"
import script from "./AddNewRecipe.vue?vue&type=script&lang=js"
export * from "./AddNewRecipe.vue?vue&type=script&lang=js"

import "./AddNewRecipe.vue?vue&type=style&index=0&id=05177395&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__